(function () {
  'use strict';

  var drawer      = document.getElementById('fcd-drawer');
  var overlay     = document.getElementById('fcd-overlay');
  var closeBtn    = document.getElementById('fcd-close');
  var list        = document.getElementById('fcd-list');
  var empty       = document.getElementById('fcd-empty');
  var emptyFooter = document.getElementById('fcd-empty-footer');
  var footer      = document.getElementById('fcd-footer');
  var totalEl     = document.getElementById('fcd-total');
  var shipBar     = document.getElementById('fcd-shipping-bar');
  var shipText    = document.getElementById('fcd-ship-text');
  var barFill     = document.getElementById('fcd-bar-fill');
  var contBtn     = document.getElementById('fcd-continue');
  var testSec     = document.getElementById('fcd-testimonials');

  if (!drawer) return;

  var threshold   = window.fcdThreshold || 0;
  var shipEnabled = window.fcdFreeShippingEnabled || false;
  var sliderContainer = document.getElementById('fcd-slider-container');
  var sliderTrack     = document.getElementById('fcd-slider-track');
  var dotsContainer   = document.getElementById('fcd-dots');
  var currentSlide    = 0;
  var slideCount      = 4;
  var autoSlideTimer  = null;
  var isDragging      = false;
  var startX          = 0;

  function initTestimonialSlider() {
    if (!sliderTrack || !dotsContainer) return;

    var slides = sliderTrack.querySelectorAll('.fcd-slide');
    slideCount = slides.length || 4;

    dotsContainer.innerHTML = '';
    for (var i = 0; i < slideCount; i++) {
      var dot = document.createElement('button');
      dot.className = 'fcd-dot' + (i === 0 ? ' fcd-dot-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.setAttribute('data-index', i);
      dot.addEventListener('click', function (e) {
        var idx = parseInt(e.currentTarget.getAttribute('data-index'));
        goToSlide(idx);
        resetAutoSlide();
      });
      dotsContainer.appendChild(dot);
    }

    if (sliderContainer) {
      sliderContainer.addEventListener('mousedown', dragStart);
      sliderContainer.addEventListener('mousemove', dragMove);
      sliderContainer.addEventListener('mouseup', dragEnd);
      sliderContainer.addEventListener('mouseleave', dragEnd);
      sliderContainer.addEventListener('touchstart', dragStart, { passive: true });
      sliderContainer.addEventListener('touchmove', dragMove, { passive: true });
      sliderContainer.addEventListener('touchend', dragEnd);
      sliderContainer.addEventListener('mouseenter', stopAutoSlide);
      sliderContainer.addEventListener('mouseleave', startAutoSlide);
    }

    startAutoSlide();
  }

  function goToSlide(index) {
    if (index < 0) index = slideCount - 1;
    if (index >= slideCount) index = 0;
    currentSlide = index;

    var percentage = -currentSlide * 100;
    if (sliderTrack) {
      sliderTrack.style.transform = 'translateX(' + percentage + '%)';
    }

    if (dotsContainer) {
      var dots = dotsContainer.querySelectorAll('.fcd-dot');
      dots.forEach(function (dot, i) {
        if (i === currentSlide) {
          dot.classList.add('fcd-dot-active');
        } else {
          dot.classList.remove('fcd-dot-active');
        }
      });
    }
  }

  function nextSlide() {
    goToSlide(currentSlide + 1);
  }

  function startAutoSlide() {
    stopAutoSlide();
    autoSlideTimer = setInterval(nextSlide, 3500);
  }

  function stopAutoSlide() {
    if (autoSlideTimer) clearInterval(autoSlideTimer);
  }

  function resetAutoSlide() {
    stopAutoSlide();
    startAutoSlide();
  }

  function dragStart(e) {
    isDragging = true;
    startX = getPositionX(e);
    stopAutoSlide();
  }

  function dragMove(e) {
    if (!isDragging) return;
    var currentPosition = getPositionX(e);
    var diff = currentPosition - startX;
    if (Math.abs(diff) > 35) {
      if (diff < 0) {
        nextSlide();
      } else {
        goToSlide(currentSlide - 1);
      }
      isDragging = false;
      startAutoSlide();
    }
  }

  function dragEnd() {
    isDragging = false;
  }

  function getPositionX(e) {
    return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
  }

  function open() {
    showLoader();
    drawer.classList.add('fcd-open');
    overlay.classList.add('fcd-on');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function close() {
    drawer.classList.remove('fcd-open');
    overlay.classList.remove('fcd-on');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  if (contBtn) {
    contBtn.addEventListener('click', function () {
      close();
      window.location.href = '/collections/all';
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target;
    var cartLink = null;

    for (var i = 0; i < 6; i++) {
      if (!el || el === document.body) break;

      var href = el.getAttribute ? el.getAttribute('href') : null;
      var isCartHref = href === '/cart' || href === window.location.origin + '/cart';

      var isCartTrigger = (
        el.classList.contains('site-header__cart') ||
        el.classList.contains('header__cart') ||
        el.classList.contains('cart-icon') ||
        el.classList.contains('cart__icon') ||
        el.classList.contains('header-cart') ||
        el.classList.contains('cart-count') ||
        el.classList.contains('cart-count-bubble') ||
        el.classList.contains('js-cart-count') ||
        el.classList.contains('mini-cart__trigger') ||
        el.classList.contains('cart-toggle') ||
        el.classList.contains('icon-cart') ||
        el.getAttribute('data-cart-toggle') !== null ||
        (el.getAttribute('aria-label') || '').toLowerCase().indexOf('cart') !== -1
      );

      if (isCartHref || isCartTrigger) { cartLink = el; break; }
      el = el.parentElement;
    }

    if (!cartLink) return;
    if (cartLink.closest('#fcd-drawer')) return;
    if (cartLink.closest('.cart-popup, .cart__popup, [class*="cart-popup"]')) return;
    if (window.location.pathname === '/cart') return;

    e.preventDefault();
    e.stopPropagation();
    open();
  });

  function fetchCart() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart.items || cart.items.length === 0) {
        render(cart, {});
        return;
      }
      fetchProductsAndRender(cart);
    })
    .catch(function (err) {
      console.error('[FCD] fetchCart error:', err);
    });
  }

  function fetchProductsAndRender(cart) {
    var handles = [];
    cart.items.forEach(function (item) {
      if (item.handle && handles.indexOf(item.handle) === -1) {
        handles.push(item.handle);
      }
    });

    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '.js', {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      var compareAtMap = {};
      products.forEach(function (product) {
        if (!product || !product.variants) return;
        product.variants.forEach(function (variant) {
          compareAtMap[variant.id] = variant.compare_at_price || null;
        });
      });

      render(cart, compareAtMap);
    });
  }

  function showLoader() {
    list.innerHTML = '<div class="fcd-loader"><div class="fcd-spin"></div></div>';
    empty.style.display       = 'none';
    emptyFooter.style.display = 'none';
    footer.style.display      = 'none';
    shipBar.style.display     = 'none';
    if (testSec) testSec.style.display = 'none';
  }

  function render(cart, compareAtMap) {
    list.innerHTML = '';

    if (!cart.items || cart.items.length === 0) {
      empty.style.display       = 'flex';
      emptyFooter.style.display = 'block';
      footer.style.display      = 'none';
      shipBar.style.display     = 'none';
      if (testSec) testSec.style.display = 'none';
      return;
    }

    empty.style.display       = 'none';
    emptyFooter.style.display = 'none';
    footer.style.display      = 'block';
    if (testSec) {
      testSec.style.display = 'block';
      initTestimonialSlider();
    }

    cart.items.forEach(function (item, idx) {
      list.appendChild(buildItem(item, idx + 1, compareAtMap));
    });

    var savingEl  = document.getElementById('fcd-saving-val');
    var savingRow = savingEl ? savingEl.closest('.fcd-saving') : null;

    var totalSaving = 0;
    cart.items.forEach(function (item) {
      var compareAt = compareAtMap[item.variant_id] || null;
      var price     = item.price || 0;
      if (compareAt && compareAt > price) {
        totalSaving += (compareAt - price) * item.quantity;
      }
    });

    if (totalSaving > 0) {
      if (savingEl)  savingEl.textContent = formatMoney(totalSaving);
      if (savingRow) savingRow.style.display = 'flex';
    } else {
      if (savingRow) savingRow.style.display = 'none';
    }

    var shippingEl = document.getElementById('fcd-shipping-val');
    if (shippingEl) shippingEl.textContent = 'Calculated at checkout';
    totalEl.textContent = formatMoney(cart.total_price);
    renderBar(cart.total_price);
  }

  function buildItem(item, lineIdx, compareAtMap) {
    var div = document.createElement('div');
    div.className = 'fcd-item';
    div.dataset.line = lineIdx;

    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
      ? item.variant_title : '';

    var maxQty = 99999;
    if (item.variant && item.variant.inventory_management
        && item.variant.inventory_policy !== 'continue') {
      maxQty = item.variant.inventory_quantity;
    }

    var priceHTML = (function () {
      var compareAt = compareAtMap[item.variant_id] || null;
      var price     = item.price || 0;

      if (compareAt && compareAt > price) {
        return (
          '<div class="fcd-item-unit-price">' +
            '<s class="fcd-original-price">' + formatMoney(compareAt) + '</s>' +
            '<span class="fcd-sale-price">'  + formatMoney(price) + '</span>' +
          '</div>'
        );
      }

      return (
        '<div class="fcd-item-unit-price">' +
          '<span class="fcd-regular-price">' + formatMoney(price) + '</span>' +
        '</div>'
      );
    }());

    var trashIcon = [
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"',
        ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
        '<polyline points="3 6 5 6 21 6"/>',
        '<path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>',
        '<path d="M10 11v6"/><path d="M14 11v6"/>',
        '<path d="M9 6V4h6v2"/>',
      '</svg>'
    ].join('');

    div.innerHTML = [
      '<div class="fcd-item-top">',
        '<div class="fcd-img">',
          '<img src="' + sizedImg(item.image, '136x136') + '" alt="' + esc(item.product_title) + '" loading="lazy">',
        '</div>',
        '<div class="fcd-info">',
          '<a class="fcd-item-title" href="' + item.url + '" title="' + esc(item.product_title) + '">' + esc(item.product_title) + '</a>',
          variant ? '<div class="fcd-item-variant">' + esc(variant) + '</div>' : '',
          priceHTML,
        '</div>',
      '</div>',
      '<div class="fcd-item-bottom">',
        '<div class="fcd-qty" data-line="' + lineIdx + '" data-max="' + maxQty + '">',
          '<button class="fcd-q-btn fcd-minus" aria-label="Decrease">−</button>',
          '<span class="fcd-q-num">' + item.quantity + '</span>',
          '<button class="fcd-q-btn fcd-plus" aria-label="Increase">+</button>',
        '</div>',
        '<div class="fcd-right">',
          '<div class="fcd-price">' + formatMoney(item.final_line_price || item.line_price) + '</div>',
          '<button class="fcd-remove" data-line="' + lineIdx + '" aria-label="Remove item">',
            trashIcon,
          '</button>',
        '</div>',
      '</div>',
    ].join('');

    return div;
  }

  list.addEventListener('click', function (e) {
    var minus  = e.target.closest('.fcd-minus');
    var plus   = e.target.closest('.fcd-plus');
    var remove = e.target.closest('.fcd-remove');

    if (minus) {
      var qtyEl = minus.closest('.fcd-qty');
      var line  = parseInt(qtyEl.dataset.line);
      var numEl = qtyEl.querySelector('.fcd-q-num');
      var cur   = parseInt(numEl.textContent);
      if (cur <= 1) { removeLine(line); }
      else { numEl.textContent = cur - 1; changeLine(line, cur - 1); }
    }

    if (plus) {
      var qtyEl = plus.closest('.fcd-qty');
      var line  = parseInt(qtyEl.dataset.line);
      var numEl = qtyEl.querySelector('.fcd-q-num');
      var cur   = parseInt(numEl.textContent);
      var max   = parseInt(qtyEl.dataset.max || 99999);
      if (cur < max) { numEl.textContent = cur + 1; changeLine(line, cur + 1); }
    }

    if (remove) {
      removeLine(parseInt(remove.dataset.line));
    }
  });

  function changeLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      fetchProductsAndRender(cart);
      updateCount(cart.item_count);
    });
  }

  function removeLine(line) {
    var item = list.querySelector('.fcd-item[data-line="' + line + '"]');
    if (item) {
      item.style.transition = 'opacity .2s, transform .2s';
      item.style.opacity    = '0';
      item.style.transform  = 'translateX(30px)';
    }
    setTimeout(function () {
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          render(cart, {});
        } else {
          fetchProductsAndRender(cart);
        }
        updateCount(cart.item_count);
      });
    }, 200);
  }

  function renderBar(totalCents) {
    if (!shipEnabled || !threshold) { shipBar.style.display = 'none'; return; }
    shipBar.style.display = 'block';
    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
    barFill.style.width = pct + '%';
    if (totalCents >= threshold) {
      shipText.className = 'fcd-ship-text fcd-congrats';
      shipText.innerHTML = 'CONGRATULATIONS! YOU\'VE GOT <strong>FREE SHIPPING!</strong> 🚚';
    } else {
      shipText.className = 'fcd-ship-text';
      var freeAt = formatMoney(threshold);
      shipText.innerHTML = 'FREE SHIPPING FOR ANY ORDERS ABOVE <span class="fcd-amt">' + freeAt + '</span>';
    }
  }

  function updateCount(n) {
    var els = document.querySelectorAll(
      '.cart-count, .cart-count-bubble, [data-cart-count], ' +
      '.site-header__cart-count, .header__cart-count, ' +
      '.js-cart-count, .cart__count, .cart-icon__count, ' +
      '.header-cart-count, [data-header-cart-count], ' +
      '#CartCount, #CartCountMob, .nh-cart-badge'
    );
    els.forEach(function (el) {
      el.textContent = n;
      if (el.classList.contains('nh-cart-badge')) {
        if (n > 0) { el.classList.remove('is-zero'); }
        else        { el.classList.add('is-zero'); }
      } else {
        el.style.display = n > 0 ? '' : 'none';
      }
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      var fmt   = (window.theme && window.theme.moneyFormat) || '${{amount}}';
      var raw   = window.Shopify.formatMoney(cents, fmt);
      var clean = raw.replace(/<[^>]+>/g, '').trim();
      if (clean) return clean;
    }
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + amount;
  }

  function sizedImg(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.?]+)(\?|$)/, '_' + size + '$1$2').replace(/^http:\/\//, 'https://');
  }

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  window.FloatingCartDrawer = { open: open, close: close, refresh: fetchCart };

})();